"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSubprojectModal = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_select_1 = require("react-select");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var memoize = require("fast-memoize");
var classNames = require("classnames");
var moment = require("moment");
var actions = require("@caddigital/sok-reducers/lib/actions/subproject");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var components_1 = require("components");
var FolderTree_1 = require("components/FolderTree");
var ImportFromProjectOverlay_1 = require("components/sidemenus/ImportFromProjectOverlay");
var sok_types_1 = require("@caddigital/sok-types");
var text_1 = require("utils/text");
var constants_1 = require("utils/constants");
var GenericConfirmDialog_1 = require("components/GenericConfirmDialog");
var avatars_1 = require("components/Avatar/avatars");
var DatePicker_1 = require("components/DatePicker");
var mapStateToProps = function (state) { return ({
    subproject: state.subproject
}); };
var mapDispatchToProps = function (dispatch) { return ({
    save: function (payload) {
        return dispatch(actions.wizard.saveRequest(payload));
    },
    fetchProjectTemplates: function () {
        return dispatch(actions.projectList.fetchRequest({ type: 'TEMPLATE' }));
    },
    fetchGroups: function (project) {
        return dispatch(actions.usergroupList.fetchRequest('PROJECT', project.id, {
            includeMembers: 'false'
        }));
    },
    setProject: function (project) {
        return dispatch(actions.wizard.setProject(project));
    },
    updateValue: function (key, value) { return dispatch(actions.wizard.updateField(key, value)); },
    updateCustommeta: function (identifier, value) {
        return dispatch(actions.wizard.updateCustommeta(identifier, value));
    },
    selectItem: function (folder, value) {
        return dispatch(actions.folderTree.selectFile(folder, value));
    },
    changeExpand: function (expand, folder) {
        return dispatch(actions.folderTree.copyChangeExpand(expand, folder));
    },
    toggleCategory: function (group, selected) {
        return dispatch(actions.wizard.toggleCategory(group, selected));
    },
    changeCategoryName: function (group, groupName) {
        return dispatch(actions.wizard.changeGategoryName(group, groupName));
    },
    getContent: function (folder) {
        return dispatch(actions.folderTree.fetchTree(folder, ['FOLDER'], 'COMPLETE'));
    },
    clearTree: function () { return dispatch(actions.folderTree.clear()); },
    changeStep: function (step) { return dispatch(actions.wizard.changeStep(step)); },
    clear: function () { return (dispatch(actions.folderTree.clear()),
        dispatch(actions.usergroupList.clear()),
        dispatch(actions.projectList.clear()),
        dispatch(actions.wizard.clear())); }
}); };
var ProjectSelect = /** @class */ (function (_super) {
    __extends(ProjectSelect, _super);
    function ProjectSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProjectSelect;
}(react_select_1.default));
var GroupSelect = /** @class */ (function (_super) {
    __extends(GroupSelect, _super);
    function GroupSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return GroupSelect;
}(react_select_1.default));
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('categories', 'setCategories', []), (0, recompose_1.withState)('responsible', 'setResponsible', []), (0, recompose_1.withState)('projects', 'setProjects', []), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('modified', 'setModified', false), (0, recompose_1.withState)('confirmationIsOpen', 'setConfirmationIsOpen', false), (0, recompose_1.withState)('metas', 'setMetas', []), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        if (this.props.subprojectIsOpen) {
            this.props.fetchProjectTemplates();
        }
    },
    componentDidUpdate: function (prevProps) {
        var _this = this;
        if (this.props.subprojectIsOpen) {
            if (this.props.subproject.wizard.status === 'FETCHED' &&
                this.props.subproject.wizard.status !==
                    prevProps.subproject.wizard.status) {
                this.props.setSubprojectIsOpen(false);
            }
            if (this.props.subprojectIsOpen !== prevProps.subprojectIsOpen) {
                this.props.fetchProjectTemplates();
                var clone = this.props.metadata.list.filter(function (x) {
                    return x.identifier !== 'subproject-status-meta' &&
                        (x.bitField & sok_types_1.CustomMeta.SUBPROJECT) > 0;
                });
                clone.reverse();
                this.props.setMetas(clone);
            }
            if (this.props.metadata.list !== prevProps.metadata.list) {
                var clone = this.props.metadata.list.filter(function (x) {
                    return x.identifier !== 'subproject-status-meta' &&
                        (x.bitField & sok_types_1.CustomMeta.SUBPROJECT) > 0;
                });
                clone.reverse();
                this.props.setMetas(clone);
            }
            var project = this.props.subproject.wizard.project;
            if (project && project !== prevProps.subproject.wizard.project) {
                if (this.props.subproject.folderTree.data.tree) {
                    this.props.clearTree();
                }
                this.props.getContent({
                    id: project.rootFolder,
                    uuid: project.rootFolderIdentifier,
                    project: project.id,
                    projectUuid: project.uuid
                });
                this.props.fetchGroups(project);
            }
            var categories = this.props.categories;
            if (this.props.subproject.usergroups.groups !==
                prevProps.subproject.usergroups.groups) {
                categories = this.props.subproject.usergroups.groups.reduce(function (acc, x) {
                    if (x.category.type === 'CategoryUserGroup') {
                        acc.push(x.category);
                    }
                    return acc;
                }, []);
                this.props.setCategories(categories);
            }
            if (categories !== prevProps.categories) {
                var columns_1 = categories.reduce(function (p, item) {
                    var length = (0, text_1.calculateStringLength)(item.name);
                    if (!p['__name'] || p['__name'] < length) {
                        p['__name'] = length;
                    }
                    return p;
                }, {
                    __name: (0, text_1.calculateStringLength)('fileListTools/subproject/name'),
                    __newName: (0, text_1.calculateStringLength)('fileListTools/subproject/newName')
                });
                // Override styles for dynamic classes
                var style = document.getElementById('SubProjectCategoriesListCSS');
                if (style && style.parentNode) {
                    style.parentNode.removeChild(style);
                }
                style = document.createElement('style');
                style.id = 'SubProjectCategoriesListCSS';
                document.head && document.head.appendChild(style);
                var sheet_1 = style.sheet;
                var contentWidth_1 = 2.5 * 13;
                Object.keys(columns_1).forEach(function (className, i) {
                    var colwidth = Math.max(8, 4 + columns_1[className] + 26); // convert to rem
                    contentWidth_1 += colwidth;
                    sheet_1.insertRule(".".concat(className) +
                        ' {max-width: ' +
                        colwidth +
                        'px;\n min-width: ' +
                        colwidth +
                        'px;}', i);
                });
                this.props.setContentWidth(contentWidth_1);
            }
            if (this.props.subproject.wizard.categories !==
                prevProps.subproject.wizard.categories) {
                var selected = Object.values(this.props.subproject.wizard.categories)
                    .sort(function (a, b) { return a.name.localeCompare(b.name); })
                    .map(function (cat) {
                    var mc = _this.props.subproject.usergroups.groups.find(function (x) { return x.category.id === cat.id; });
                    var groups = (mc && mc.groups) || [];
                    return {
                        label: cat.name,
                        options: groups.sort(function (a, b) { return a.name.localeCompare(b.name); })
                    };
                });
                this.props.setResponsible(selected);
            }
            if (this.props.subproject.projects.list !==
                prevProps.subproject.projects.list) {
                var projectMap = this.props.subproject.projects.list.reduce(function (acc, item) {
                    var key = item.customerName || '-';
                    var list = acc[key] || [];
                    list.push(item);
                    acc[key] = list;
                    return acc;
                }, {});
                var projects = Object.entries(projectMap)
                    .map(function (_a) {
                    var customer = _a[0], projects = _a[1];
                    projects.sort(function (a, b) { return a.name.localeCompare(b.name); });
                    return {
                        label: customer,
                        options: projects
                    };
                })
                    .sort(function (a, b) { return a.label.localeCompare(b.label); });
                this.props.setProjects(projects);
            }
        }
        else {
            if (this.props.subprojectIsOpen !== prevProps.subprojectIsOpen) {
                this.props.clear();
                this.props.setModified(false);
            }
        }
    }
}), recompose_1.pure);
var timeout = null;
var Input = (0, recompose_1.compose)((0, recompose_1.withState)('tempValue', 'setTempValue', null), recompose_1.pure)(function (props) { return (React.createElement(sok_ui_1.TextInput, { placeholder: props.placeholder, value: props.tempValue === null ? props.value : props.tempValue, onBlur: function () {
        if (props.tempValue !== null) {
            if (timeout) {
                clearTimeout(timeout);
            }
            props.onChange(props.tempValue);
            props.setTempValue(null);
        }
    }, onChange: function (e) {
        var value = e.target.value;
        props.setTempValue(value);
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function () {
            props.onChange(value);
            props.setTempValue(null);
        }, constants_1.SEARCH_TIMEOUT);
    } })); });
function getError(props, field) {
    if (props.subproject.wizard.errors) {
        var validations = props.subproject.wizard.errors[field];
        if (validations) {
            return React.createElement("div", { className: 'validation-error' }, validations[0]);
        }
    }
    return React.createElement("div", { className: 'validation-error' });
}
function getHeaderColumn(props, name, identifier) {
    var dataKey = '__' + identifier;
    return (React.createElement("div", { key: identifier, "data-key": dataKey, "data-length": name.length, className: classNames('row__column dynamic briefcase-list-row-column', dataKey) }, (0, translation_1.getLocalization)("fileListTools/subproject/column/".concat(name))));
}
var NoCategoriesPlaceHolder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-categories', className: 'no-categories' }),
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9'), width: 200, height: 200 }),
    React.createElement("b", null, (0, translation_1.getLocalization)('global/dearSokoProUser')),
    React.createElement("span", null, (0, translation_1.getLocalization)("fileListTools/subproject/noCategories")))); };
var HeaderComponent = function (props) {
    var keys = Object.keys(props.subproject.wizard.categories);
    var isSelected = props.categories.length > 0
        ? props.categories.length === keys.length
        : false;
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-check', onClick: function (e) {
                    e.stopPropagation();
                    props.toggleCategory(props.categories, !isSelected);
                }, className: isSelected ? 'selected' : null })),
        getHeaderColumn(props, 'category', 'name'),
        getHeaderColumn(props, 'newName', 'newName')));
};
var createRowData = memoize(function (items, categories, toggleCategory, changeCategoryName, modified, setModified) { return ({
    items: items,
    categories: categories,
    toggleCategory: toggleCategory,
    changeCategoryName: changeCategoryName,
    modified: modified,
    setModified: setModified
}); });
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var items = data.items, categories = data.categories, toggleCategory = data.toggleCategory, changeCategoryName = data.changeCategoryName;
    var row = items[index];
    var selected = categories[row.id];
    var isSelected = selected !== undefined;
    return (React.createElement("div", { className: 'row', style: style },
        React.createElement("div", { className: 'row__column narrow' },
            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-check', onClick: function (e) {
                    e.stopPropagation();
                    toggleCategory([row], !isSelected);
                }, className: isSelected ? 'selected' : null })),
        React.createElement("div", { className: "row__column dynamic __name", "data-key": "__name" }, row.name),
        React.createElement("div", { className: "row__column dynamic __newName", "data-key": "__newName" },
            React.createElement(sok_ui_1.TextInput, { disabled: !isSelected, value: selected ? selected.name : row.name, onChange: function (_a) {
                    var value = _a.target.value;
                    return changeCategoryName(selected, value);
                }, onBlur: function () {
                    if (selected) {
                        var trimmed = selected.name.trim();
                        if (trimmed.length === 0) {
                            changeCategoryName(selected, row.name);
                            !data.modified && data.setModified(true);
                        }
                        else if (trimmed !== selected.name) {
                            changeCategoryName(selected, trimmed);
                            !data.modified && data.setModified(true);
                        }
                    }
                } }))));
});
var subprojectSteps = [
    'basicInformation',
    'projectTemplateAndFolders',
    'categories',
    'subprojectMetadata'
];
var EmptyComponent = function () { return React.createElement("div", null); };
var components = [
    function (props) { return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'field', key: 'nameYourProject' },
            React.createElement("label", null, (0, translation_1.getLocalization)('fileListTools/subproject/nameYourProject')),
            React.createElement(Input, { value: props.subproject.wizard.name, onChange: function (value) {
                    props.updateValue('name', value);
                    !props.modified && props.setModified(true);
                } }),
            getError(props, 'name')),
        React.createElement("div", { className: 'field', key: 'description' },
            React.createElement("label", null, (0, translation_1.getLocalization)('fileListTools/subproject/description')),
            React.createElement(Input, { value: "".concat(props.subproject.wizard.metas['description-meta'] || ''), onChange: function (value) {
                    props.updateCustommeta('description-meta', value);
                    !props.modified && props.setModified(true);
                } })),
        React.createElement("div", { className: 'field', key: 'notifyFollowingRecipients' },
            React.createElement("label", null, (0, translation_1.getLocalization)('fileListTools/subproject/notifyFollowingRecipients')),
            React.createElement(Input, { value: props.subproject.wizard.notifyFollowing, onChange: function (value) {
                    props.updateValue('notifyFollowing', value);
                    !props.modified && props.setModified(true);
                } }),
            getError(props, 'notifyFollowing')))); },
    function (props) { return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'field', key: 'project' },
            React.createElement("label", null, (0, translation_1.getLocalization)('fileListTools/subproject/project')),
            React.createElement(ProjectSelect, { menuPlacement: 'auto', classNamePrefix: 'react-select', id: 'project-template', isLoading: props.subproject.projects.status === 'FETCHING', value: props.subproject.wizard.project, options: props.projects, isSearchable: true, getOptionValue: function (opt) { return opt.id; }, getOptionLabel: function (opt) { return opt.name; }, onChange: function (x) {
                    x && props.setProject(Array.isArray(x) ? x[0] : x);
                    !props.modified && props.setModified(true);
                } })),
        React.createElement("div", { className: 'list', key: 'selectedFolders' },
            React.createElement("label", null, (0, translation_1.getLocalization)('fileListTools/subproject/selectFolders')),
            !props.subproject.folderTree.data.tree &&
                props.subproject.folderTree.data.status === 'FETCHING' && (React.createElement("div", { className: 'loading' },
                React.createElement(sok_ui_1.LoadingSpinner, null))),
            props.subproject.wizard.project &&
                props.subproject.folderTree.data.tree &&
                (props.subproject.folderTree.data.tree.getRoot().getChildren()
                    .length === 0 ? (React.createElement("div", { className: 'empty-project' },
                    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9') }),
                    React.createElement("span", { className: 'title' }, (0, translation_1.getLocalization)('global/dearSokoProUser')),
                    React.createElement("span", { className: 'message' }, (0, translation_1.getLocalization)('fileListTools/subproject/emptyProject')))) : (React.createElement(FolderTree_1.default, { parentIdentifier: props.subproject.wizard.project.rootFolderIdentifier, tree: props.subproject.folderTree.data.tree, selectItem: function () {
                        var x = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            x[_i] = arguments[_i];
                        }
                        props.selectItem.apply(props, x);
                        !props.modified && props.setModified(true);
                    }, changeExpand: props.changeExpand, getContent: props.getContent })))))); },
    function (props) {
        var itemData = createRowData(props.categories, props.subproject.wizard.categories, props.toggleCategory, props.changeCategoryName, props.modified, props.setModified);
        return (React.createElement("div", { className: 'subproject-categories-list-container' },
            React.createElement("div", { className: 'sok-list-content subproject-categories-list ' +
                    props.subproject.usergroups.status.toLowerCase() },
                props.subproject.usergroups.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                            return props.subproject.wizard.project &&
                                props.fetchGroups(props.subproject.wizard.project);
                        } }))),
                props.subproject.folderTree.data.status === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'loading' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.subproject.usergroups.status === 'FETCHED' &&
                    props.categories && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(sok_ui_1.List, { itemCount: props.categories.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(HeaderComponent, __assign({}, props)), placeholder: React.createElement(NoCategoriesPlaceHolder, null) }, ListRow));
                })))));
    },
    function (props) { return (React.createElement(React.Fragment, null, props.metas.map(function (x) {
        var val = props.subproject.wizard.metas[x.identifier];
        if (x.identifier === 'subproject-responsible-person-meta') {
            var cat = val &&
                props.subproject.usergroups.groups.find(function (x) { return x.groups.findIndex(function (z) { return z.id === val; }) > -1; });
            var g = (cat && cat.groups.find(function (x) { return x.id === val; })) || undefined;
            return (React.createElement("div", { className: 'field', key: 'metadata-' + x.identifier },
                React.createElement("label", null, (0, translation_1.getLocalization)("subprojectMeta/".concat(x.name))),
                React.createElement(GroupSelect, { classNamePrefix: 'react-select', menuPlacement: 'auto', value: g, options: props.responsible, getOptionLabel: function (opt) { return opt.name; }, getOptionValue: function (opt) { return opt.id; }, onChange: function (group) {
                        group &&
                            props.updateCustommeta(x.identifier, Array.isArray(group) ? group[0].id : group.id);
                        !props.modified && props.setModified(true);
                    }, isClearable: false })));
        }
        else if (x.type === 'select') {
            var options = (x.options || [])
                .sort(function (a, b) { return a.order - b.order; })
                .map(function (v) { return ({ value: v.value, name: v.name }); });
            var selected = (val && x.options && x.options.find(function (o) { return o.value === val; })) || null;
            var meta = (0, translation_1.getLocalization)("subprojectMeta/".concat(x.name));
            return (React.createElement("div", { className: 'field', key: 'metadata-' + x.identifier },
                React.createElement("label", null, meta),
                React.createElement(react_select_1.default, { classNamePrefix: 'react-select', placeholder: "".concat((0, translation_1.getLocalization)('global/select'), " ").concat(meta.toLowerCase()), menuPlacement: 'auto', isDisabled: !x.editable, value: selected, options: options, getOptionLabel: function (opt) { return opt.name; }, getOptionValue: function (opt) { return opt.value; }, onChange: function (_a) {
                        var value = _a.value;
                        props.updateCustommeta(x.identifier, value);
                        !props.modified && props.setModified(true);
                    }, isClearable: false })));
        }
        else if (x.type === 'day') {
            return (React.createElement("div", { className: 'field', key: 'metadata-' + x.identifier },
                React.createElement("label", null, (0, translation_1.getLocalization)("subprojectMeta/".concat(x.name))),
                React.createElement(DatePicker_1.DatePicker, { selected: val ? moment(val) : undefined, onChange: function (value) {
                        props.updateCustommeta(x.identifier, value ? value.toDate().getTime() : null);
                        !props.modified && props.setModified(true);
                    } })));
        }
        return (React.createElement("div", { className: 'field', key: 'metadata-' + x.identifier },
            React.createElement("label", null, (0, translation_1.getLocalization)("subprojectMeta/".concat(x.name))),
            React.createElement(Input, { value: val ? val.toString() : '', onChange: function (value) {
                    props.updateCustommeta(x.identifier, value);
                    !props.modified && props.setModified(true);
                } })));
    }))); }
];
exports.CreateSubprojectModal = enhance(function (props) {
    var step = props.subproject.wizard.step;
    var StepComponent = components[step] || EmptyComponent;
    function tryClose(status) {
        if (!status && props.modified) {
            return props.setConfirmationIsOpen(true);
        }
        props.setSubprojectIsOpen(status);
    }
    return (React.createElement(sok_ui_1.Overlay, { isOpen: props.subprojectIsOpen },
        React.createElement(sok_ui_1.SideMenu, { className: 'subproject-sidemenu', isOpen: props.subprojectIsOpen, docked: false, orientation: 'right' },
            React.createElement(sok_ui_1.Header, { onClose: function () { return tryClose(false); } }, (0, translation_1.getLocalization)('fileListTools/subproject/header')),
            React.createElement(sok_ui_1.Container, null,
                React.createElement(sok_ui_1.RequestStatusBox, { status: props.subproject.wizard.status, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILED'] },
                    (0, translation_1.getLocalization)('subproject/create/status/saving'),
                    (0, translation_1.getLocalization)('subproject/create/status/saved'),
                    (0, translation_1.getLocalization)('subproject/create/status/failed')),
                React.createElement("div", null,
                    React.createElement(sok_ui_1.StepBar, { currentStep: step, steps: subprojectSteps.map(function (x) {
                            return (0, translation_1.getLocalization)("fileListTools/subproject/".concat(x));
                        }) })),
                React.createElement("div", { className: 'disclaimer' }, (0, translation_1.getLocalization)("fileListTools/subproject/".concat(subprojectSteps[step], "/disclaimer"))),
                React.createElement(StepComponent, __assign({}, props)),
                React.createElement(GenericConfirmDialog_1.GenericConfirmDialog, { firstRow: (0, translation_1.getLocalization)('subproject/wizard/unsavedChanges'), secondRow: (0, translation_1.getLocalization)('subproject/wizard/areYouSure'), isOpen: props.confirmationIsOpen, setIsOpen: props.setConfirmationIsOpen, confirm: function () {
                        props.setConfirmationIsOpen(false);
                        props.setSubprojectIsOpen(false);
                    } })),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement(sok_ui_1.Button, { color: 'blue', icon: React.createElement(Icon_1.Icon, { className: 'fa-chevron-left' }), text: (0, translation_1.getLocalization)('buttons/previous'), disabled: step < 1, onClick: function () {
                        props.changeStep(step - 1);
                    } }),
                React.createElement(sok_ui_1.Button, { color: 'blue', iconRight: React.createElement(Icon_1.Icon, { className: 'fa-chevron-right' }), text: (0, translation_1.getLocalization)('buttons/next'), disabled: step > 2, onClick: function () {
                        props.changeStep(step + 1);
                    } }),
                React.createElement(sok_ui_1.Button, { color: 'green', iconRight: React.createElement(Icon_1.Icon, { className: 'fa-piggy-bank' }), text: (0, translation_1.getLocalization)('buttons/create'), disabled: step < 3 || props.subproject.wizard.status === 'FETCHING', onClick: function () {
                        if (props.currentFolder === null) {
                            return;
                        }
                        var selected = [];
                        var ignored = {};
                        var wizard = props.subproject.wizard;
                        var categories = Object.values(wizard.categories);
                        var tree = props.subproject.folderTree.data.tree;
                        if (tree) {
                            var picked = {};
                            (0, ImportFromProjectOverlay_1.traverseSelected)(tree.getRoot(), selected, picked, ignored);
                        }
                        props.save({
                            type: 'SUBPROJECT',
                            name: wizard.name,
                            notify: wizard.notifyFollowing.split(',').map(function (x) { return x.trim(); }),
                            categories: categories,
                            parent: props.currentFolder.id,
                            customMeta: wizard.metas,
                            folders: {
                                ids: selected.map(function (x) { return x.getValue().id; }),
                                excluded: Object.values(ignored).map(function (x) { return x.getValue().id; })
                            }
                        });
                    } }),
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', iconRight: React.createElement(Icon_1.Icon, { className: 'fa-times-circle' }), text: (0, translation_1.getLocalization)('buttons/cancel'), disabled: props.subproject.wizard.status === 'FETCHING', onClick: function () {
                        tryClose(false);
                    } })))));
});
